import { render, staticRenderFns } from "./like.vue?vue&type=template&id=84fd8c96&scoped=true"
import script from "./like.vue?vue&type=script&lang=js"
export * from "./like.vue?vue&type=script&lang=js"
import style0 from "./like.vue?vue&type=style&index=0&id=84fd8c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fd8c96",
  null
  
)

export default component.exports